export const home_overview = '/v1/oauth/aG9tZV9vdmVydmlldw==';
